export const numericRegExp = new RegExp(/^[\d]+$/g);
